import ReviewImg from "../assets/images/review-img.jpg";

export const reviewList = [
  {
    rating: 5,
    title:
      "“Very happy with our choice to take our daughter to Brave care. The entire team was great! Thank you!”",
    name: "Shahnewaz Sakil",
    role: "UI/UX Designer",
    image: ReviewImg,
    duration: "3 Months Ago",
  },
  {
    rating: 3,
    title:
      "“Thanks for all your efforts and teamwork over the last several months!  Thank you so much”",
    name: "James Dopli",
    role: "Developer",
    image: ReviewImg,
    duration: "6 Months Ago",
  },
  {
    rating: 4,
    title:
      "“ How you use the city or town name is up to you. All results may be freely used in any work.”",
    name: "Julias Roy",
    role: "CO Founder",
    image: ReviewImg,
    duration: "12 Months Ago",
  },
  {
    rating: 4,
    title:
      "“ How you use the city or town name is up to you. All results may be freely used in any work.”",
    name: "Arista Williamson",
    role: "CO Founder",
    image: ReviewImg,
    duration: "9 Months Ago",
  },
];
